import { AccountContext } from 'src/contexts'

/**
 * Hook that retrieves the id of the current connected user
 */
export default function useAccountId() {
  const {
    account: { id },
  } = AccountContext.use()

  return id
}
